
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.013 7.947a.445.445 0 00.432.553h.15a.405.405 0 01.362.585L2.65 11.702a1 1 0 01-.447.447l-.557.278a1 1 0 00-.26.188l-.092.092a1 1 0 00-.293.707V16a1 1 0 001 1c.552 0 .98.474 1.244.959a2 2 0 003.512 0C7.02 17.474 7.448 17 8 17h8c.552 0 .98.474 1.244.959a2 2 0 003.512 0C21.02 17.474 21.448 17 22 17a1 1 0 001-1V7a1 1 0 00-1-1H4.28a1 1 0 00-.97.757l-.297 1.19zM11 15.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v7zm5-5v-2a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5zM7.5 8H5.809a.5.5 0 00-.447.276l-1.5 3a.5.5 0 00.447.724H7.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z","fill":"currentColor"}})])
          )
        }
      }
    